import React from 'react';

import PopoverMenuItem from "../popover-menu/popover-menu-item-depricated/popover-menu-item";
import toggleItemPin from "./actions/pin-item"
import {SESSION_PINS_CHANGED} from "../../gd/bus/bus-event-type";

type Props = {
    data            : {
        taskId?         : ID,
        projectId?      : ID,
        documentId?     : ID,
        userId?         : ID,
        organizationId? : ID,
        chatId?         : ID,
        customViewId?   : ID
    }
    disabled?           : boolean
}

type State = {
    isPagePinned        : boolean
}

export default class PinPopoverMenuItem extends React.Component<Props,State> {

    // static propTypes = {
    //
    //     data: PropTypes.shape({
    //         taskId: PropTypes.string,
    //         projectId: PropTypes.string,
    //         documentId: PropTypes.string,
    //         userId: PropTypes.string,
    //         organizationId: PropTypes.string,
    //         chatId: PropTypes.string,
    //         customViewId: PropTypes.string
    //     }),
    //
    //     disabled: PropTypes.bool,
    // }

    constructor(props:any) {
        super(props);

        this.state = {
            isPagePinned: !!gd.session.pins.getPinId(this.props.data)
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps:any) {
        this.setState({
            isPagePinned: !!gd.session.pins.getPinId(nextProps.data)
        });
    }

    componentDidMount() {
        gd.bus.subscribe(SESSION_PINS_CHANGED, this, this.sessionDataChanged)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    sessionDataChanged = () => {
        this.setState({
            isPagePinned: !!gd.session.pins.getPinId(this.props.data)
        });
    };

    onPinClick = async () => {
        const isPagePinned = await toggleItemPin(this.props.data)

        if (!isPagePinned) {
            // remove pin - close more?
        }

        this.setState({isPagePinned:isPagePinned})
    }

    render() {
        if (this.state.isPagePinned) {
            return <PopoverMenuItem label="Unpin from home menu" icon="i5-pin-full" disabled={this.props.disabled} onClick={this.onPinClick} />;
        } else {
            return <PopoverMenuItem label="Pin to home menu" icon="i5-pin" disabled={this.props.disabled} onClick={this.onPinClick} />
        }
    }
}
